import * as React from "react";
import { Card, CardContent, Container, Grid, Paper, Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const CockpitSkeleton = () => {
  return (
    <>
      <br />
      <Container maxWidth="xl">
        <Paper elevation={2} variant="outlined">
          <Grid container justifyContent="space-around" spacing={2}>
            {/* 3 kolon skeleton */}
            {[1, 2, 3].map(col => (
              <Grid key={col} item xs={4} container direction="column" alignItems="center">
                {/* Her kolonda 2-3 card skeleton */}
                {[1, 2].map(card => (
                  <Card key={card} style={{ marginBottom: 5, marginTop: 15, width: "100%" }}>
                    <CardContent>
                      <Skeleton variant="text" width="60%" height={30} />
                      <Skeleton variant="rect" width="100%" height={200} style={{ marginTop: 10 }} />
                      <Box display="flex" justifyContent="space-around" mt={2}>
                        <Skeleton variant="text" width="30%" />
                        <Skeleton variant="text" width="30%" />
                        <Skeleton variant="text" width="30%" />
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
      <br />

      {/* Büyük chart skeletonları */}
      <Container maxWidth="xl">
        <Paper elevation={2} variant="outlined">
          <CardContent>
            <Skeleton variant="text" width="40%" height={40} />
            <Skeleton variant="rect" width="100%" height={300} style={{ marginTop: 20 }} />
          </CardContent>
        </Paper>
      </Container>
      <br />

      <Container maxWidth="xl">
        <Paper elevation={2} variant="outlined">
          <CardContent>
            <Skeleton variant="text" width="40%" height={40} />
            <Skeleton variant="rect" width="100%" height={300} style={{ marginTop: 20 }} />
          </CardContent>
        </Paper>
      </Container>
      <br />
    </>
  );
};

export default CockpitSkeleton;
